import React from 'react';
import PropTypes from 'prop-types';
import Button from '../buttons/button';
import Overlay from '../overlay';
import giveWarning from '../__utils/warning';
import classNames from 'classnames';

import './style.scss';

const Modal = ({
  isOpen,
  title,
  onClose,
  children,
  supportingText,
  onAfterOpen,
  actions,
  label = 'Hudl Modal',
  size = 'default',
  cancelText = 'Cancel',
  showCancelAction = true,
  contentOverflowVisible,
  parentSelector,
  maxHeight,
  height,
  className,
  qaId,
}) => {
  const modalBodyClasses = classNames('uni-modal', className, {
    'uni-modal--large': size === 'large',
    'uni-modal--overflow-visible': contentOverflowVisible,
  });
  const modalContentClasses = classNames('uni-modal__content', {
    'uni-modal--overflow-visible': contentOverflowVisible,
  });

  let modalActions;

  const modalStyle = { content: {}, overlay: {} };
  const modalContentStyle = {};
  if (isOpen) {
    if (typeof maxHeight !== 'undefined') {
      modalStyle.content.maxHeight = maxHeight;
      modalContentStyle.maxHeight = 'none';
    }
    if (typeof height !== 'undefined') {
      modalStyle.content.height = height;
    }
  }

  if (actions) {
    modalActions = Array.isArray(actions) ? [...actions] : [actions];
  }

  // DEPRECATION
  if (maxHeight || height || contentOverflowVisible) {
    giveWarning(
      'The height, maxHeight, and contentOverflowVisible props are deprecated and will be removed in the next major ' +
        'release of uniform-ui-components. Use the className prop instead.'
    );
  }

  return (
    <Overlay
      isOpen={isOpen}
      title={title}
      label={label}
      parentSelector={parentSelector}
      className={modalBodyClasses}
      style={modalStyle}
      qaId={qaId}
      onAfterOpen={onAfterOpen}
      onClose={onClose}
    >
      <div id="overlayContent" className={modalContentClasses} style={modalContentStyle}>
        {children}
      </div>

      {(modalActions || supportingText) && (
        <div className="uni-modal__footer">
          <h5 className="uni-modal__footer-text">{supportingText}</h5>

          <div className="uni-modal__footer-actions">
            {showCancelAction && <Button type="cancel" text={cancelText} onClick={onClose} />}
            {modalActions && modalActions.reverse().map((item, index) => React.cloneElement(item, { key: index }))}
          </div>
        </div>
      )}
    </Overlay>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  label: PropTypes.string,
  children: PropTypes.node,
  actions: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  supportingText: PropTypes.node,
  size: PropTypes.oneOf(['default', 'large']),
  onAfterOpen: PropTypes.func,
  showCancelAction: PropTypes.bool,
  contentOverflowVisible: PropTypes.bool,
  cancelText: PropTypes.any,
  parentSelector: PropTypes.func,
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  qaId: PropTypes.string,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/modal/index.jsx